import React from 'react';
import styled from 'styled-components';
import authActions from '../ducks/auth/actions';
import { useSelector } from 'react-redux';
import { ReactComponent as GoBackIcon } from '../assets/icons/icon-chevron-left.svg';
import { useDispatch } from 'react-redux';

const ImpersonatingWrapper = styled.div`
  position: absolute;
`;

const FlagWrapper = styled.div`
  transition-duration: 0.3s;
  cursor: pointer;
  width: ${Math.sqrt(50 ** 2 + 100 ** 2)}px;
  height: 30px;
  background-color: var(--blue-color);
  position: relative;
  top: 15px;
  left: -30px !important;
  transform: rotate(-47deg);
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  z-index: 200;
  font-size: 10px !important;
  box-shadow: 1px 1px 3px 2px rgba(0, 0, 0, 0.2);
  span {
    font-weight: bold;
  }
  &:hover{
    background-color: #e74c3c;
    transition-duration: 0.3s;

  }
`;
export default function ImpersonatingFlag() {
  const dispatch = useDispatch();
  const { impersonating = false } = useSelector(state => state.auth);
  const [isHovered, setHover] = React.useState();
  function handleReturnAdminSide() {
    dispatch(authActions.impersonateRollback());
  }
  return (
    impersonating && (
      <ImpersonatingWrapper>
        <FlagWrapper
          onClick={handleReturnAdminSide}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
        >
          {isHovered ? <span>Despersonificar</span> : <span>Personificado</span>}
        </FlagWrapper>
      </ImpersonatingWrapper>
    )
  );
}
